import { Component, OnInit } from '@angular/core';
import {first} from "rxjs/operators";
import {DeviceDetectorService} from "ngx-device-detector";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import {PropertiesService} from "../../../../admin/admin-services/properties.service";
import { IconComponent } from '../../icons-svgs/icons-svgs.component';

@Component({
    selector: 'app-accommodation-booking-documents',
    templateUrl: './accommodation-booking-documents.component.html',
    styleUrls: ['./accommodation-booking-documents.component.scss'],
    standalone: true,
    imports: [IconComponent, TranslateModule]
})
export class AccommodationBookingDocumentsComponent implements OnInit {
  isMobile: boolean;

  constructor(
    private mobileDetector: DeviceDetectorService,

  ) { }
  ngOnInit(): void {
    this.isMobile = this.mobileDetector.isMobile();
  }



}
